import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {MapAsMainViewVariant, OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {ILatestQuery} from "../../../utils/latest_query";

const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.MAP_AS_MAIN_VIEW);

export const useMapTestQuery = (query: ILatestQuery, blockParamAdd: boolean = false) => {
    const testProps = useABTest(abTestProps);

    if (testProps.abTestVariant && testProps.abTestVariant === MapAsMainViewVariant.MAIN_VIEW_MAP && !blockParamAdd) {
        return {...query, sol: "true"};
    }

    return query;
};
import {useABTest} from "@pg-mono/ab-testing";

import {abTestingInstance} from "../../../ab_testing/ab_testing_instance";
import {MapAsMainViewVariant, OngoingABTests} from "../../../ab_testing/ongoing_ab_tests";
import {ILatestQuery} from "../../../utils/latest_query";

const abTestProps = abTestingInstance.getABTestContainerProps(OngoingABTests.MAP_AS_MAIN_VIEW);

export const useMapTestQuery = (query: ILatestQuery, blockParamAdd: boolean = false) => {
    const testProps = useABTest(abTestProps);

    if (testProps.abTestVariant && testProps.abTestVariant === MapAsMainViewVariant.MAIN_VIEW_MAP && !blockParamAdd) {
        return {...query, sol: "true"};
    }

    return query;
};
